import { render, staticRenderFns } from "./InputTextareaCpt.vue?vue&type=template&id=5a5bb6ca&scoped=true&"
import script from "./InputTextareaCpt.vue?vue&type=script&lang=ts&"
export * from "./InputTextareaCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bb6ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
